import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import SidebarWithHeader from "@/layouts/Sidebar/SidebarWithHeader.vue"
	
	// router
	import {
		useRoute
	} from "vue-router"

	// vue
	import {
		computed,
		ref
	} from "vue"

	
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	// components
	const route = useRoute()
	const isLoaded = ref(true)

	const layout = computed(() => {
		return route.meta.layout || SidebarWithHeader
	})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (isLoaded.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), {
        key: 0,
        class: "p-0 m-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})